import axios from 'axios';
import Cookies from 'universal-cookie';

const getAuthHeaders = () => {
  const cookies = new Cookies();
  const token = cookies.get('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const buildUrl = (path) => {
  const base = window.API_BASE_URL || '';
  const normalizedBase = base.replace(/\/+$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  if (/\/api$/i.test(normalizedBase) && /^\/api\//i.test(normalizedPath)) {
    return `${normalizedBase}${normalizedPath.replace(/^\/api/i, '')}`;
  }

  return `${normalizedBase}${normalizedPath}`;
};

export const downloadConversationsExcel = async (rows) => {
  const response = await axios.post(
    buildUrl('/api/conversations/export/excel'),
    { rows },
    {
      responseType: 'blob',
      headers: { ...getAuthHeaders() },
    }
  );

  const contentType = response.headers?.['content-type'] || 'application/octet-stream';
  const blob = new Blob([response.data], { type: contentType });
  const url = window.URL.createObjectURL(blob);

  const contentDisposition = response.headers?.['content-disposition'];
  const filenameMatch = contentDisposition && /filename=([^;\n]+)/i.exec(contentDisposition);
  const filename = (filenameMatch?.[1] || '').replace(/"/g, '').trim()
    || `Conversaciones_${new Date().toISOString().slice(0, 10)}.xlsx`;

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();

  window.URL.revokeObjectURL(url);

  return response;
};
